import {Box, Button, Grid, Paper, Skeleton, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {PopupMessage} from "../../utils/message";
import {Helpers} from "../../utils/helpers";
import CircularProgress, {CircularProgressProps} from '@mui/material/CircularProgress';

export class DuplicateName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            amount: 0,
            requestAmount: 0,
        }
    }

    componentDidMount(): void {
        this.getDuplicateNameCount();
    }

    async getDuplicateNameCount() {
        const url = `${Config.getInstance.apiUrl}/api/duplicate-name/amount`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.setState({loading: true});

        const response = await axios.get(url, {headers});

        const data = response.data;
        const success = data.success;
        if (success) {
            const amount = data.amount;
            this.setState({amount, loading: false});
            PopupMessage.success(`Amount of duplicate names: ${amount}`);
        } else {
            PopupMessage.error("Failed to get amount")
        }
    }

    async onFix() {
        const url = `${Config.getInstance.apiUrl}/api/duplicate-name/fix`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const body = {
            amount: this.state.requestAmount || 0,
        }
        this.setState({loading: true});

        const response = await axios.post(url, body, {headers});
        this.setState({loading: false});

        const data = response.data;
        const success = data.success;
        if (success) {
            PopupMessage.success("Fixed duplicate names");
            this.onWriteFile(data.data);
        } else {
            PopupMessage.error("Failed to fix duplicate names")
        }

        await this.getDuplicateNameCount();
    }

    async onWriteFile(data: {id: string, oldName: string, newName: string}[]) {
        // Write to csv file with columns: id, oldName, newName

        let content = "id,oldName,newName\n";
        data.forEach((item) => {
            content += `${item.id},${item.oldName},${item.newName}\n`;
        });

        const csvData = new Blob([content], {type: 'text/csv'});
        const csvUrl = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = csvUrl;
        link.download = 'duplicate-names.csv';
        link.click();
    }

    renderFilter() {
        return <Paper className="root" elevation={0} style={{padding: '20px', marginBottom: '20px'}}>
            <Grid container spacing={2}>
                <Grid item sm={3}>
                    <TextField
                        id="search"
                        label="Amount"
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={this.state.requestAmount}
                        onChange={(e) => this.setState({requestAmount: e.target.value})}
                    />
                </Grid>
                <Grid item sm={3}>
                    <Button variant="contained" color="primary" onClick={() => this.onFix()}>
                        Fix
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        if (this.state.loading) {
            return <Box sx={{display: 'flex'}}>
                <CircularProgress />
            </Box>
        }

        return null;
    }

    render() {
        return <div className="contentPadding" style={{width: "100%"}}>
            {/* <Paper className="root" elevation={0}> */}
            <Typography variant="h2" style={{marginBottom: '50px'}}>
                Duplicate Name Amount: {this.state.amount}
            </Typography>

            <Grid container spacing={2}>
                <Grid item sm={12}>
                    {this.renderFilter()}
                </Grid>
                <Grid item sm={12}>
                    {this.renderContent()}
                </Grid>
            </Grid>
            {/* </Paper> */}
        </div>
    }
}